module.exports = __webpack_public_path__ + "img/IMG_0240.56512d13.png";